import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import styles from './connectionModal.mod.scss';
import { getAgentDownloadLink } from '../../../helpers/AgentDownloadLink';
import { useBlockly } from '@modules/blockly/features/hooks';
import {
  webSerialModalChangeStep,
  webSerialModalClose,
  build,
} from '@modules/blockly/features/blocklySlice';
import clsx from 'clsx';


const ConnectionModal = (props) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const blocklyState = useBlockly();

  const open = blocklyState.webSerialModal.open;
  const id = props.id || '--';
  const isChromeOS = props.isChromeOS || false;
  const isMicrobit = props.isMicrobit || false;
  const userAgent = props.userAgent || {};
  const setAgent = props.setAgent || null;
  const socket = props.socketAgent || null;
  const buildingFunction = props.buildingFunction || null;

  useEffect(() => {
    if (open) {
      $(`#webSerialModal-${id}`).modal('show');
    } else {
      $(`#webSerialModal-${id}`).modal('hide');
    }
  }, [open]);

  const changeStep = (step) => {
    dispatch(webSerialModalChangeStep(step));
    if (step === 2 && socket.agentType !== 'serial' && socket.agentType !== 'usb') {
      if (setAgent) {
        setAgent((isMicrobit) ? 'usb' : 'serial');
      }
    }
  };

  const downloadAgent = () => {
    if (setAgent) {
      setAgent('socket');
    }
    const link = getAgentDownloadLink(userAgent);
    window.open(link, '_blank', 'noreferrer');
    dispatch(webSerialModalClose());
  };

  const closeModal = () => {
    dispatch(webSerialModalClose());
  };

  const build = () => {
    dispatch(webSerialModalClose());
    if (buildingFunction) {
      buildingFunction();
    }
  };

  const microbitForceDownload = () => {
    dispatch(webSerialModalClose());
    dispatch(build({ microbitForceDownload: true }));
  };

  const changeLink = () => {
    const { changeWebSerialLink } = props;
    if (changeWebSerialLink) {
      changeWebSerialLink();
    }
  };

  return (
    <div className={clsx('modal', 'fade', 'webSerialModal', styles.connectionModal)} data-backdrop="static" data-keyboard="false" id={`webSerialModal-${id}`} tabIndex="-1" role="dialog" aria-labelledby={`webSerialModal-${id}-label`} aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className={clsx('modal-content', styles.content)}>
          <div className="modal-header">
            <h5 className="modal-title" id={`webSerialModal-${id}-label`}>
              {isChromeOS && blocklyState.webSerialModal.step === 0 ? (
                intl.formatMessage({ id: 'blocks.blockly.webserialModal.step0.title' })
              ) : ('')}
              {!isChromeOS && blocklyState.webSerialModal.step === 0 ? (
                intl.formatMessage({ id: 'blocks.blockly.webserialModal.step0.titleChrome' })
              ) : ('')}
              {blocklyState.webSerialModal.step === 1 ? (
                intl.formatMessage({ id: 'blocks.blockly.webserialModal.step1.title' })
              ) : ('')}
              {blocklyState.webSerialModal.step === 2 ? (
                intl.formatMessage({ id: 'blocks.blockly.webserialModal.step2.title' })
              ) : ('')}
              {blocklyState.webSerialModal.step === 3 ? (
                intl.formatMessage({ id: 'blocks.blockly.webserialModal.step3.title' })
              ) : ('')}
              {blocklyState.webSerialModal.connected && blocklyState.webSerialModal.step === 4 ? (
                intl.formatMessage({ id: 'blocks.blockly.webserialModal.step4.title' })
              ) : ('')}
              {!blocklyState.webSerialModal.connected && blocklyState.webSerialModal.error && blocklyState.webSerialModal.step === 4 ? (
                <div style={{ margin: 'auto' }}>
                  {intl.formatMessage({ id: 'blocks.blockly.webserialModal.step4.titleError' })}
                </div>
              ) : ('')}
            </h5>
            <button type="button" className="close" onClick={closeModal} aria-label="Close"><span aria-hidden="true">&times;</span></button>
          </div>

          <div className="modal-body">
            {!isChromeOS && blocklyState.webSerialModal.step === 0 && !isMicrobit ? (
              <>
                <div>{intl.formatMessage({ id: 'blocks.blockly.webserialModal.step0.messageLine1' })}</div>
                <div>{intl.formatMessage({ id: 'blocks.blockly.webserialModal.step0.messageLine2' })}</div>
              </>
            ) : ('')}
            {!isChromeOS && blocklyState.webSerialModal.step === 0 && isMicrobit ? (
              <>
                <div>{intl.formatMessage({ id: 'blocks.blockly.webserialModal.step0.messageLine1Microbit' })}</div>
                <div>{intl.formatMessage({ id: 'blocks.blockly.webserialModal.step0.messageLine2Microbit' })}</div>
              </>
            ) : ('')}
            {isChromeOS && blocklyState.webSerialModal.step === 0 ? (
              <>
                <div>{intl.formatMessage({ id: 'blocks.blockly.webserialModal.step0.messageLine1Chrome' })}</div>
                <div>{intl.formatMessage({ id: 'blocks.blockly.webserialModal.step0.messageLine2Chrome' })}</div>
              </>
            ) : ('')}
            {blocklyState.webSerialModal.step === 1 && !isMicrobit ? (
              <div className="two-columns">
                <div><img src="/images/creabots/web_serial/webserial_1.png" width="300" alt="" /></div>
                <div className={styles.columnTwo}>texto</div>
              </div>
            ) : ('')}
            {blocklyState.webSerialModal.step === 1 && isMicrobit ? (
              <div className="step-one"><img src="/images/web_serial/webserial_1_microbit.gif" width="300" alt="" /></div>
            ) : ('')}
            {blocklyState.webSerialModal.step === 2 ? (
              <div className="two-columns">
                <div>
                  <div>
                    {!isMicrobit ? (
                      <img src="/images/creabots/web_serial/webserial_1.png" width="400" alt="" />
                    ) : (
                      <img src="/images/web_serial/webserial_2_microbit.gif" width="348" alt="" />
                    )}
                  </div>
                </div>
                <div className={styles.columnTwo}>
                  <div dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'blocks.blockly.webserialModal.step2.messageLine1' }) }} />
                  <div dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'blocks.blockly.webserialModal.step2.messageLine2' }) }} />
                  <div dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'blocks.blockly.webserialModal.step2.messageLine3' }) }} />
                </div>
              </div>
            ) : ('')}
            {blocklyState.webSerialModal.step === 3 ? (
              <div className="loading">
                <div><img src="/images/web_serial/linking.png" width="80" alt="" /></div>
                <div>{intl.formatMessage({ id: 'blocks.blockly.webserialModal.step3.messageLine1' })}</div>
              </div>
            ) : ('')}
            {!blocklyState.webSerialModal.connected && blocklyState.webSerialModal.error && blocklyState.webSerialModal.step === 4 ? (
              <div className={styles.error}>
                <div dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'blocks.blockly.webserialModal.step4.messageLine2Error' }) }} />
                <div><img src="/images/creabots/web_serial/webserial_4_error.png" width="120" alt="" /></div>
              </div>
            ) : ('')}
            {blocklyState.webSerialModal.connected && blocklyState.webSerialModal.step === 4 ? (
              <div className="two-columns">
                <div>
                  {!isMicrobit ? (
                    <div><img src="/images/creabots/web_serial/webserial_3.png" width="400" alt="" /></div>
                  ) : (
                    <div><img src="/images/web_serial/webserial_3_microbit.png" width="348" alt="" /></div>
                  )}
                </div>
                <div className={styles.columnTwo}>
                  <div>{intl.formatMessage({ id: 'blocks.blockly.webserialModal.step4.messageLine1' })}</div>
                  <div>{intl.formatMessage({ id: 'blocks.blockly.webserialModal.step4.messageLine2' })}</div>
                </div>
              </div>
            ) : ('')}
          </div>

          <div className="modal-footer">
            {!isChromeOS && blocklyState.webSerialModal.step === 0 ? (
              <>
                {'serial' in navigator || 'usb' in navigator ? (
                  <button type="button" className="btn btn-secondary" onClick={() => changeStep(blocklyState.webSerialModal.step + 2)}>
                    {intl.formatMessage({ id: 'blocks.blockly.webserialModal.buttons.continueBrowser' })}
                  </button>
                ) : ('')}
                {isMicrobit ? (
                  <button type="button" className="btn btn-primary main-btn" onClick={microbitForceDownload}>
                    {intl.formatMessage({ id: 'blocks.blockly.webserialModal.buttons.downloadFile' })}
                  </button>
                ) : (
                  <button type="button" className="btn btn-primary main-btn" onClick={downloadAgent}>
                    {intl.formatMessage({ id: 'blocks.blockly.webserialModal.buttons.downloadPlugin' })}
                  </button>
                )}
              </>
            ) : ('')}
            {isChromeOS && blocklyState.webSerialModal.step === 0 ? (
              <button type="button" className="btn btn-secondary" onClick={() => changeStep(blocklyState.webSerialModal.step + 2)}>
                {intl.formatMessage({ id: 'blocks.blockly.webserialModal.buttons.continue' })}
              </button>
            ) : ('')}
            {blocklyState.webSerialModal.step === 1 ? (
              <button type="button" className="btn btn-primary main-btn" onClick={() => changeStep(blocklyState.webSerialModal.step + 1)}>
                {intl.formatMessage({ id: 'blocks.blockly.webserialModal.buttons.next' })}
              </button>
            ) : ('')}
            {blocklyState.webSerialModal.step === 2 ? (
              <button type="button" className="btn btn-primary main-btn" onClick={changeLink}>
                {intl.formatMessage({ id: 'blocks.blockly.webserialModal.buttons.link' })}
              </button>
            ) : ('')}
            {!blocklyState.webSerialModal.connected && blocklyState.webSerialModal.error && blocklyState.webSerialModal.step === 4 ? (
              <button type="button" className="btn btn-primary main-btn" style={{ margin: 'auto' }} onClick={changeLink}>
                {intl.formatMessage({ id: 'blocks.blockly.webserialModal.buttons.retry' })}
              </button>
            ) : ('')}
            {blocklyState.webSerialModal.connected && blocklyState.webSerialModal.step === 4 ? (
              <button type="button" className="btn btn-primary main-btn" onClick={build} aria-label="Close">
                {intl.formatMessage({ id: 'blocks.blockly.webserialModal.buttons.ok' })}
              </button>
            ) : ('')}
          </div>
        </div>
      </div>
    </div>
  );
};


export default ConnectionModal;